import React, { useEffect, useState, useRef } from 'react';
import { Stage, Layer, Rect, Line, Text } from 'react-konva';
import { Button } from '@mui/material';
import { jsPDF } from 'jspdf';

const JohariPenceresi = () => {
  const [shapes, setShapes] = useState([]);
  const gridSize = 400;
  const gridSpacing = 50; // Adjusting grid spacing to match the reference image
  const stageRef = useRef(null);

  useEffect(() => {
    const newShapes = [];
    const numbers = [15, 20, 25, 30, 35, 40, 45]; // Numbering for the grid lines
    const center = gridSize / 2;

    // Create grid lines
    for (let i = 0; i <= gridSize; i += gridSpacing) {
      newShapes.push(
        <Line key={`h${i}`} points={[i, 0, i, gridSize]} stroke="#ddd" strokeWidth={1} />,
        <Line key={`v${i}`} points={[0, i, gridSize, i]} stroke="#ddd" strokeWidth={1} />
      );
    }

    // Add numbers on the grid
    numbers.forEach((num, index) => {
      const xPos = gridSpacing * (index + 1) - 10; // Positioning numbers
      const yPos = gridSpacing * (index + 1) - 10;

      // Adding labels at top, bottom, left, and right
      newShapes.push(
        <Text key={`bottomLabel${index}`} x={xPos} y={gridSize + 5} text={num.toString()} fontSize={12} />,
        <Text key={`topLabel${index}`} x={xPos} y={-20} text={num.toString()} fontSize={12} />,
        <Text key={`leftLabel${index}`} x={-25} y={yPos} text={num.toString()} fontSize={12} />,
        <Text key={`rightLabel${index}`} x={gridSize + 5} y={yPos} text={num.toString()} fontSize={12} />
      );
    });

    // Add axes lines (X and Y axes)
    newShapes.push(
      <Line key="xAxis" points={[center, 0, center, gridSize]} stroke="black" strokeWidth={2} />,
      <Line key="yAxis" points={[0, center, gridSize, center]} stroke="black" strokeWidth={2} />
    );

    // Add rectangles in quadrants
    newShapes.push(
      <Rect key="rect1" x={60} y={60} width={50} height={30} stroke="black" strokeWidth={1} />,
      <Rect key="rect2" x={300} y={60} width={50} height={30} stroke="black" strokeWidth={1} />,
      <Rect key="rect3" x={60} y={300} width={50} height={30} stroke="black" strokeWidth={1} />,
      <Rect key="rect4" x={300} y={300} width={50} height={30} stroke="black" strokeWidth={1} />
    );

    // Add axis labels ("GERİBİLDİRİM" and "AÇIKLIK")
    newShapes.push(
      // Horizontal axis ("GERİBİLDİRİM")
      <Text key="labelBottom" x={center - 25} y={gridSize + 20} text="GERİBİLDİRİM" fontSize={16} />,
      <Text key="labelTop" x={center - 25} y={-40} text="GERİBİLDİRİM" fontSize={16} />,
      
      // Vertical axis ("AÇIKLIK")
      <Text key="labelLeft" x={-50} y={center - 25} text="AÇIKLIK" rotation={-90} fontSize={16} />,
      <Text key="labelRight" x={gridSize + 40} y={center - 25} text="AÇIKLIK" rotation={90} fontSize={16} />
    );

    setShapes(newShapes);
  }, []);

  const handleDownload = () => {
    const stage = stageRef.current;
    const dataUrl = stage.toDataURL({ pixelRatio: 3, width: gridSize + 200, height: gridSize + 200 }); // Further increased canvas size
    const pdf = new jsPDF('l', 'mm', 'a4');
    const imgProps = pdf.getImageProperties(dataUrl);
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    // Adjust margins if necessary
    const margin = 30; // Increased margin
    pdf.addImage(dataUrl, 'PNG', margin, margin, pdfWidth - 2 * margin, pdfHeight - 2 * margin);
    pdf.save('johari_penceresi.pdf');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Stage width={gridSize + 50} height={gridSize + 50} ref={stageRef} style={{ backgroundColor: 'white' }}>
        <Layer>
          {shapes}
        </Layer>
      </Stage>
      <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleDownload}
                  sx={{
                    position: 'absolute',
                    right: 16,
                    bottom: 16,
                    px: '10px',
                    color: "white",
                    borderRadius: "10px", // Rounded corners
                    "&:hover": {
                      backgroundColor: "#115293",
                      transform: "scale(1.001)", // Subtle hover effect
                    },
                  }}
                >
                  ÇIKTI AL
                </Button>
    </div>
  );
};

export default JohariPenceresi;